import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Col, Container, Row } from 'react-bootstrap';
import Blockquote from '../../../components/Blockquote';
import Link from '../../../components/Link';
import NumberInput from '../../../components/NumberInput';
import Support from '../../../components/Support/Support';
import SupportMobile from '../../../components/Support/SupportMobile';

export type StepProps = {
  data: any;
  collectStepData: (data: any) => void;
};

const SavingsContribution = ({ data, collectStepData }: StepProps) => {
  const handleBeforeTaxOption = (e: number | null | undefined) => {
    collectStepData({
      ...data,
      beforeTax: e,
    });
  };

  const handleRoth401Option = (e: number | null | undefined) => {
    collectStepData({
      ...data,
      roth401: e,
    });
  };

  const handleAfterTaxOption = (e: number | null | undefined) => {
    collectStepData({
      ...data,
      afterTax: e,
    });
  };

  const handleBeforeTaxCatchUpOption = (e: number | null | undefined) => {
    collectStepData({
      ...data,
      beforeTaxCatchUp: e,
    });
  };

  const handleRoth401CatchUpOption = (e: number | null | undefined) => {
    collectStepData({
      ...data,
      roth401CatchUp: e,
    });
  };

  const calculateTotalContribution = () => {
    const { beforeTax, roth401, afterTax, beforeTaxCatchUp, roth401CatchUp } =
      data;

    let totalSum = 0;

    if (beforeTax) {
      totalSum += beforeTax;
    }
    if (roth401) {
      totalSum += roth401;
    }
    if (afterTax) {
      totalSum += afterTax;
    }
    if (beforeTaxCatchUp) {
      totalSum += beforeTaxCatchUp;
    }
    if (roth401CatchUp) {
      totalSum += roth401CatchUp;
    }

    return totalSum;
  };

  return (
    <Container className="p-0 d-flex flex-row">
      <div className={'col-12 col-lg-8'}>
        <section className={'col-12'}>
          <div className="d-flex flex-row justify-content-between">
            <h5 className={'mt-12 text-sm-20-lg-24'}>
              How much would you like to contribute?
            </h5>
            <div className={'mt-12 text-sm-20-lg-24 d-lg-none'}>
              <SupportMobile>
                <div className="p-0 mt-3">
                  <span className="fw-light text-sub1">
                    Here are a few things that will guide you to make the best
                    decision
                  </span>
                  <Link
                    rightIcon={light('chevron-right')}
                    onSelect={(selectedKey) =>
                      console.log(`selected ${selectedKey}`)
                    }
                    eventKey="test"
                    className="pt-3"
                    isAlignAtEnd
                    isBlue
                  >
                    <span className="text-caption lh-xs">Tax Breakdown</span>
                  </Link>
                  <Link
                    rightIcon={light('chevron-right')}
                    onSelect={(selectedKey) =>
                      console.log(`selected ${selectedKey}`)
                    }
                    eventKey="test"
                    className="pt-3"
                    isAlignAtEnd
                    isBlue
                  >
                    <span className="text-caption lh-xs">Min/Max Chart</span>
                  </Link>
                  <Link
                    rightIcon={light('chevron-right')}
                    onSelect={(selectedKey) =>
                      console.log(`selected ${selectedKey}`)
                    }
                    eventKey="test"
                    className="pt-3"
                    isAlignAtEnd
                    isBlue
                  >
                    <span className="text-caption lh-xs">
                      Contribution Calculator
                    </span>
                  </Link>
                </div>
              </SupportMobile>
            </div>
          </div>
          <div
            className={
              'mt-7 mt-lg-3 fw-light text-fs-6 lh-xs text-ligther-grey'
            }
          >
            <p>
              See your contribution, potential company match and how much your
              account could be worth at retirement if you begin contributing.
            </p>
          </div>
        </section>
        <section className="col-12 mt-12 p-10 p-lg-11 bg-white rounded-1">
          <Row className="m-0 p-10 p-lg-0 pt-lg-6 d-flex flex-column flex-lg-row justify-content-lg-between">
            <Col className="p-0 d-flex flex-column flex-lg-column-reverse">
              <span className="pt-lg-3  text-sub1 fw-light text-lg-dark-gray-sm-darker-gray">
                Per Paycheck Contribution
              </span>
              <span className="pt-3 pt-lg-0 text-indigo fw-light text-fs-4">
                $250
              </span>
            </Col>
            <Col className="p-0 d-flex flex-column mt-12 mt-lg-0 flex-lg-column-reverse align-items-lg-center">
              <span className="pt-lg-3 text-sub1 fw-light text-lg-dark-gray-sm-darker-gray">
                Potential Company match
              </span>
              <span className="pt-3 pt-lg-0 text-indigo fw-light text-fs-4">
                $150
              </span>
            </Col>
            <Col className="p-0 d-flex flex-column mt-12 mt-lg-0 flex-lg-column-reverse align-items-lg-end">
              <span className="pt-lg-3 text-sub1 fw-light text-lg-dark-gray-sm-darker-gray">
                Estimated Growth by Age 65
              </span>
              <span className="pt-3 pt-lg-0 text-indigo fw-light text-fs-4">
                $150,000
              </span>
            </Col>
          </Row>
          <Row className="m-0 mb-5 mt-11">
            <Blockquote>
              <div>
                <p className="m-0 text-sub1 fw-bolder text-ligther-grey">
                  <span>Did You Know?</span>
                </p>
                <div className="fw-light text-caption lh-xs pt-3 d-flex align-items-center">
                  <span className="mx-3 custom-bullet bg-info"></span>
                  <span>Company Match is 6%</span>
                </div>
                <div className="fw-light text-caption lh-xs pt-3 d-flex align-items-center">
                  <span className="mx-3 custom-bullet bg-info"></span>
                  <span>Contribution range is from 1 - 50%</span>
                </div>
                <div className="fw-light text-caption lh-xs pt-3 d-flex align-items-center">
                  <span className="mx-3 custom-bullet bg-info"></span>
                  <span>
                    Your controbution is $250, but an estimated $188 comes out
                    per paycheck
                  </span>
                </div>
              </div>
            </Blockquote>
          </Row>
        </section>
        <section className="col-12 mt-12 p-10  bg-white rounded-1">
          <h6 className={'fw-normal'}>Adjust Elections</h6>
          <Row className="m-0 mt-12 justify-content-lg-between">
            <Col className="p-0 pe-2 col-7 col-lg-9">
              <div className="text-sub">Before-Tax</div>
              <div className="text-sub1 text-light-grey-normal pt-2">
                Reduce current taxable income and earnings grow tax deferred
              </div>
            </Col>
            <Col className="p-0 ps-3" style={{ maxWidth: 126 }}>
              <NumberInput
                placeholder={'0'}
                value={data.beforeTax || 0}
                onChange={(e) => handleBeforeTaxOption(e)}
                isPercent
                minValue={'0'}
                maxValue={'100'}
              />
            </Col>
          </Row>
          <Row className="m-0 mt-7 pt-6 border-top-light-gray justify-content-lg-between">
            <Col className="p-0 pe-2 col-7 col-lg-9">
              <div className="text-sub">Roth 401(k)</div>
              <div className="text-sub1 text-light-grey-normal pt-2">
                Contributions and earnings grow tax free
              </div>
            </Col>
            <Col className="p-0 ps-3" style={{ maxWidth: 126 }}>
              <NumberInput
                placeholder={'0'}
                value={data.roth401 || 0}
                onChange={(e) => handleRoth401Option(e)}
                isPercent
                minValue={'0'}
                maxValue={'100'}
              />
            </Col>
          </Row>
          <Row className="m-0 mt-7 pt-6 border-top-light-gray justify-content-lg-between">
            <Col className="p-0 pe-2 col-7 col-lg-9">
              <div className="text-sub">After-Tax (max of 7%)</div>
              <div className="text-sub1 text-light-grey-normal pt-2">
                For saving contributions with tax deferred earnings outside of
                the IRS limits
              </div>
            </Col>
            <Col className="p-0 ps-3" style={{ maxWidth: 126 }}>
              <NumberInput
                placeholder={'0'}
                value={data.afterTax || 0}
                onChange={(e) => handleAfterTaxOption(e)}
                isPercent
                minValue={'0'}
                maxValue={'100'}
              />
            </Col>
          </Row>
          <Row className="m-0 mt-7 pt-6 border-top-light-gray justify-content-lg-between">
            <Col className="p-0 pe-2 col-7 col-lg-9">
              <div className="text-sub">Before-Tax Catch-up</div>
              <div className="text-sub1 text-light-grey-normal pt-2">
                Contributions and earnings grow tax free
              </div>
            </Col>
            <Col className="p-0 ps-3" style={{ maxWidth: 126 }}>
              <NumberInput
                placeholder={'0'}
                value={data.beforeTaxCatchUp || 0}
                onChange={(e) => handleBeforeTaxCatchUpOption(e)}
                isPercent
                minValue={'0'}
                maxValue={'100'}
              />
            </Col>
          </Row>
          <Row className="m-0 mt-7 pt-6 border-top-light-gray justify-content-lg-between">
            <Col className="p-0 pe-2 col-7 col-lg-9">
              <div className="text-sub">Roth 401(k) Catch-up</div>
              <div className="text-sub1 text-light-grey-normal pt-2">
                Contributions and earnings grow tax free
              </div>
            </Col>
            <Col className="p-0 ps-3" style={{ maxWidth: 126 }}>
              <NumberInput
                placeholder={'0'}
                value={data.roth401CatchUp || 0}
                onChange={(e) => handleRoth401CatchUpOption(e)}
                isPercent
                minValue={'0'}
                maxValue={'100'}
              />
            </Col>
          </Row>
          <Row className="m-0 mt-7 py-9 px-7 light-grey-bg border-top-light-gray border-bottom-light-gray-lg">
            <Col className="p-0 col-9">
              <h6 className="m-0 fw-light text-indigo">
                Your total contribution
              </h6>
            </Col>
            <Col className="p-0 d-flex flex-column align-items-end">
              <h6
                className={`m-0 fw-light ${
                  calculateTotalContribution() < 6 ? 'text-danger' : ''
                }`}
              >
                {calculateTotalContribution()}%
              </h6>
            </Col>
          </Row>
          {calculateTotalContribution() < 6 && (
            <Row className="m-0 mt-10">
              <Blockquote variant="warning-bg" lineVariant="warning">
                <div>
                  <p className="m-0 text-sub1 fw-bolder text-red-darker lh-xs">
                    <span>You're not meeting the company match of 6%.</span>
                  </p>
                  <p className="m-0 pt-3 text-sub1 fw-light">
                    <span>Don’t leave free money on the table!</span>
                  </p>
                </div>
              </Blockquote>
            </Row>
          )}
        </section>
      </div>
      <div className="d-none d-lg-block col-lg-4">
        <section className="mt-12">
          <Support>
            <div className="p-0">
              <span className="fw-light text-sub1">
                Here are a few things that will guide you to make the best
                decision
              </span>
              <Link
                rightIcon={light('chevron-right')}
                onSelect={(selectedKey) =>
                  console.log(`selected ${selectedKey}`)
                }
                eventKey="test"
                className="pt-3"
                isAlignAtEnd
                isBlue
              >
                <span className="text-caption lh-xs">Tax Breakdown</span>
              </Link>
              <Link
                rightIcon={light('chevron-right')}
                onSelect={(selectedKey) =>
                  console.log(`selected ${selectedKey}`)
                }
                eventKey="test"
                className="pt-3"
                isAlignAtEnd
                isBlue
              >
                <span className="text-caption lh-xs">Min/Max Chart</span>
              </Link>
              <Link
                rightIcon={light('chevron-right')}
                onSelect={(selectedKey) =>
                  console.log(`selected ${selectedKey}`)
                }
                eventKey="test"
                className="pt-3"
                isAlignAtEnd
                isBlue
              >
                <span className="text-caption lh-xs">
                  Contribution Calculator
                </span>
              </Link>
            </div>
          </Support>
        </section>
      </div>
    </Container>
  );
};

export default SavingsContribution;
